import React from 'react';
import { AcceptInviteSectionView } from './section';
import './AcceptInviteSection.css';

export function AcceptInviteSection() {
  return <AcceptInviteSectionView />;
}

export default AcceptInviteSection;

